import * as React from 'react';
import autobind from 'autobind-decorator';

// Components
import CourseContent from '../Components/CourseContent';

// Utils
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import getCookie from 'Utils/GetCookie';
import Navbar from 'Screens/Layout/Common/Components/Navbar';
import { Button } from 'react-bootstrap';
import { MdImportExport } from "react-icons/md";
import { RiFileAddLine } from "react-icons/ri";


interface IProps {
    match: any;
}

interface IState {
    course: any;
    pages: any;
    pageRef: string;
    order: boolean;
}

export default class CourseBodyInstructorPage extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        let pageRef = this.props.match.params.pageRef;
        if (!pageRef) {
            pageRef = 'content';
        }
        this.state = {
            pages: [],
            course: null,
            pageRef: pageRef,
            order: false
        };
    }

    public componentDidMount() {
        this.loadData();
    }

    public componentDidUpdate() {
        let sideListNode = document.getElementById('sideList');
        let selectedLinkNodes = sideListNode.querySelectorAll('li.selectedLink');
        if (selectedLinkNodes) {
            Array.prototype.forEach.call(selectedLinkNodes, node => {
                node.classList.remove('selectedLink');
            });
        }

        sideListNode = document.getElementById(`sideList-${this.state.pageRef}`);
        if (sideListNode) {
            sideListNode.classList.add('selectedLink');
        }
        let pageNode = document.getElementsByClassName('sortable-items')[0];
        if (pageNode) {
            if (this.state.order) {
                pageNode.classList.add('sortable-items');
            } else {
                pageNode.classList.remove('sortable-items');
            }
        }
    }

    @autobind
    private loadData() {
        let url = `/courseware/api/course/${this.props.match.params.courseId}/data/?format=json`;
        fetch(url)
            .then(response => response.json())
            .then(response => {
                this.setState({
                    course: response['course'],
                    pages: response['pages']
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    @autobind
    private addPage(data) {
        let url = `/courseware/api/course/${this.props.match.params.courseId}/add_page/?format=json`;
        fetch(
            url,
            {
                method: 'POST',
                headers: { 'X-CSRFToken': getCookie('csrftoken') },
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then(response => {
                let pages = this.state.pages;
                pages.push(response);
                this.setState({
                    pages: pages,
                    pageRef: response.id
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    @autobind
    private saveOrder(data) {
        let url = `/courseware/api/course/${this.props.match.params.courseId}/reorder_pages/?format=json`;
        fetch(
            url,
            {
                method: 'PATCH',
                headers: { 'X-CSRFToken': getCookie('csrftoken') },
                body: JSON.stringify(data)
            })
            .then(() => {
                displayGlobalMessage('Successfully reordered the pages', 'success');
                // this.saveOrderSuccess('#sideList');
            })
            .catch(error => {
                console.log(error);
            });
    }

    @autobind
    private handleDeletePage(pageid) {
        let pageNode = document.getElementById(`sideList-${pageid}`);
        pageNode.parentNode.removeChild(pageNode);
        window.history.pushState('', '', `/frontend/courseware/course/${this.props.match.params.courseId}/content/`);
        this.setState({ pageRef: 'content' });
    }

    @autobind
    private handleClick(pageRef) {
        window.history.pushState('', '', `/frontend/courseware/course/${this.props.match.params.courseId}/${pageRef}/`);
        let sideListNode = document.getElementById('sideList');
        let selectedLinkNodes = sideListNode.querySelectorAll('li.selectedLink');
        if (selectedLinkNodes) {
            Array.prototype.forEach.call(selectedLinkNodes, node => {
                node.classList.remove('selectedLink');
            });
        }
        sideListNode = document.getElementById(`sideList-${pageRef}`);
        if (sideListNode) {
            sideListNode.classList.add('selectedLink');
        }
        this.setState({ pageRef: pageRef });
    }

    private myhandleSortClick() {
        // this.handleSortClick('#sideList', 'li.page');
    }

    private myhandleSaveOrder() {
        // this.handleSaveOrder('#sideList', 9);
    }

    private goToAssignmentsUrl() {
        window.location.href = `/assignments/${this.props.match.params.courseId}`;
    }

    public render() {
        console.log(this.state.course);
        if (!this.state.course) {
            return <div>Loading...</div>;
        }

        let pages = this.state.pages.map(page => (
            <li
                key={`p_${page.id}`}
                id={`sideList-${page.id}`}
                onClick={() => this.handleClick(page.id)}
                className='page'>
                {page.title}
            </li>
        ));

        let page_order = null;
        if (pages.length > 0) {
            if (!this.state.order) {
                page_order = (
                    <li id='pageReorder' className='pagesort-btn' onClick={this.myhandleSortClick}>
                        <span className='glyphicon glyphicon-sort' />&nbsp;&nbsp;Reorder Pages
                    </li>
                );
            } else {
                page_order = (
                    <li id='pageOrderSave' className='pagesort-btn' onClick={this.myhandleSaveOrder}>
                        <span className='glyphicon glyphicon-save' />&nbsp;&nbsp;Save Current Order
                    </li>
                );
            }
        }

        return (
            <React.Fragment>
                <Navbar navbarClass="navbar-light" />
                <div className="courseHeader">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 courseHeaderTitle">{this.state.course.title}</div>
                        </div>
                    </div>
                </div>
                <div id='courseBody' className='d-flex flex-row container'>
                    <div className='col-xl-3 sideListContainer'>
                        {/* <h6>Course Content</h6> */}
                        <ul id='sideList' role='menu' aria-labelledby='dLabel'>
                            <li className="level-1">Course Content</li>
                            <li className="level-2" onClick={() => this.handleClick('content')} id='sideList-content'>Multimedia Book</li>
                            <li className="level-2" onClick={() => this.handleClick('content')} id='sideList-content'>Assignments</li>
                            <li className="level-3" onClick={() => this.handleClick('content')} id='sideList-content'>Programming</li>
                            <li className="level-3" onClick={() => this.handleClick('content')} id='sideList-content'>Other Labs</li>
                            <li className="level-2" onClick={() => this.handleClick('content')} id='sideList-content'>About Course</li>
                            <hr />
                            <li className="level-1">Interactions</li>
                            <li className="level-2" onClick={() => this.handleClick('schedule')} id='sideList-schedule'>Schedule</li>
                            <li className="level-2" onClick={() => this.handleClick('discussion-forum')} id='sideList-discussion-forum'>Discussion Forum</li>
                            <li className="level-2" onClick={() => this.handleClick('email')} id='sideList-email'>Email + Archive</li>
                            <hr />
                            <li className="level-1">Performance</li>
                            <li className="level-2" onClick={() => this.handleClick('exams')} id='sideList-progress'>In/out video quizzes</li>
                            <li className="level-2" onClick={() => this.handleClick('marks')} id='sideList-progress'>Grades</li>
                            <li className="level-2" onClick={() => this.handleClick('progress')} id='sideList-progress'>Leaderboard</li>
                            <hr />
                            <li className="level-1">Course Management</li>
                            <li className="level-2" onClick={() => this.handleClick('settings')} id='sideList-settings'>Settings</li>
                            <li className="level-2" onClick={() => this.handleClick('information')} id='sideList-information'>
                                People
                            </li>
                            <li
                                className="level-white d-flex justify-content-between"
                            >
                                <Button variant="light" id='sideList-add-page' className="btn btn-sm border"> <RiFileAddLine size={18} color="#3f3f3f" className="mr-2" />Add Page</Button>
                                <Button variant="light" className="btn btn-sm border"><MdImportExport color="#3f3f3f" size={20} /></Button>
                            </li>

                            {page_order}
                            {pages}
                        </ul>
                    </div>

                    <div id='course-content-div' className='col-xl-9'>
                        <CourseContent
                            id={this.state.pageRef}
                            courseid={this.props.match.params.courseId}
                            forumid={null}
                            callback={this.addPage}
                            groupid={null}
                            deleteCallBack={this.handleDeletePage} />
                    </div>
                </div>

            </React.Fragment>
        );
    }
};
